<div class="seccion-media">
  <h2>Prensa</h2>
</div>
<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>
<div class="seccion-media">
  <div class="prensa">
    <mat-card class="nota" *ngFor="let nota of notas">
      <!-- <iframe width="350vw" height="315" src="https://www.youtube.com/embed/0kp0AyqtUYw?si=L-0TNAm2_bsuWD_Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
      <!-- <img mat-card-image [src]="post.imageUrl" [alt]="post.title" (click)="onClick(post)"/> -->
      <a [href]="nota.webUrl || nota.videoUrl">
        <h3>{{ nota.title }}</h3>
        <span>{{ nota.date | date:'yyyy MMM dd' : 'UTC'}}</span>
      </a>
      <!-- <mat-card-subtitle>{{ nota.date | date: 'EEEE, d \'de\' MMMM \'de\' yyyy' }}</mat-card-subtitle> -->
      <!-- <mat-card-content>
      <p>{{ nota.excerpt }}</p>
    </mat-card-content> -->
    </mat-card>
  </div>
</div>